module.exports = __webpack_public_path__ + "static/media/image10.2629fca3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image10.jpg
// module id = 44
// module chunks = 0